var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 271,
    height: 185,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.317,
    cy: 135.037,
    r: 9.861,
    stroke: "#fff",
    strokeOpacity: 0.06,
    strokeWidth: 3.944,
    transform: "rotate(10 93.317 135.037)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.317,
    cy: 135.037,
    r: 29.582,
    stroke: "#fff",
    strokeOpacity: 0.06,
    strokeWidth: 7.888,
    transform: "rotate(10 93.317 135.037)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.545,
    cy: 134.877,
    r: 54.233,
    stroke: "#fff",
    strokeOpacity: 0.06,
    strokeWidth: 7.888,
    transform: "rotate(10 93.545 134.877)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.317,
    cy: 135.037,
    r: 78.884,
    stroke: "#fff",
    strokeOpacity: 0.06,
    strokeWidth: 7.888,
    transform: "rotate(10 93.317 135.037)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.545,
    cy: 134.877,
    r: 103.536,
    stroke: "#fff",
    strokeOpacity: 0.06,
    strokeWidth: 7.888,
    transform: "rotate(10 93.545 134.877)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.317,
    cy: 135.037,
    r: 128.187,
    stroke: "#fff",
    strokeOpacity: 0.06,
    strokeWidth: 7.888,
    transform: "rotate(10 93.317 135.037)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.545,
    cy: 134.877,
    r: 152.838,
    stroke: "#fff",
    strokeOpacity: 0.06,
    strokeWidth: 7.888,
    transform: "rotate(10 93.545 134.877)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAsset);
export default __webpack_public_path__ + "static/media/circle-asset.49a133ccbdae5771bb6e41c95b08b62d.svg";
export { ForwardRef as ReactComponent };